import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { navigationUrlForNewApplication } from '../service/navigation-urls';
import { getUser } from '@portal-workspace/grow-ui-library';
import { CONSENT_DASHBOARD_ACCESS_LEVEL } from '@portal-workspace/grow-shared-library';

// Consent dashboard is internal-only (INTERNAL_LEVELS). Non-internal users are bounced to the
// default landing page.
export const consentDashboardAccessGuard = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser();

    if (user?.priviledges.some(priviledge => CONSENT_DASHBOARD_ACCESS_LEVEL.includes(priviledge))) {
      return true;
    }
    return router.navigate(navigationUrlForNewApplication());
  };
};
